import { render, staticRenderFns } from "./EditIterAcceptanceDialog.vue?vue&type=template&id=275940a5&scoped=true"
import script from "./EditIterAcceptanceDialog.vue?vue&type=script&lang=ts"
export * from "./EditIterAcceptanceDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditIterAcceptanceDialog.vue?vue&type=style&index=0&id=275940a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275940a5",
  null
  
)

export default component.exports